import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expand-message",
  "use": "expand-message-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"expand-message\"><path d=\"M22 12v10H2V2h10V0H2C.9 0 0 .9 0 2v20c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V12h-2z\" /><path d=\"M24 8V1c0-.552-.448-1-1-1h-7v2h4.585L12 10.586 13.415 12 22 3.416V8h2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol